var map = {
	"./Banner0.webp": 65018,
	"./Banner0iPad.webp": 36008,
	"./Banner1.webp": 58418,
	"./Banner1iPad.webp": 29879,
	"./Banner2.webp": 21252,
	"./Banner2iPad.webp": 36356
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32265;